// A subcatchment CAN have several rows naming the same LID control (e.g.
// two separate batches of rain barrels with different areas) — unlike
// coverages.ts, this is NOT deduplicated by (subcatchment, LID).

import { parseNum } from "./parseNum.ts";
import { writeOrDeleteSection } from "./writeOrDeleteSection.ts";

export interface LidUsageRow {
  subcatchment: string;
  lidControl: string;
  number: number;
  area: number;
  width: number;
  initSat: number;
  fromImperv: number;
  toPerv: boolean;
  fromPerv: number;
  reportFile: string;
  drainTo: string;
}

export function readLidUsage(
  raw: ReadonlyMap<string, string[][]>,
  warnings?: Set<string>
): LidUsageRow[] {
  const rows = raw.get("LID_USAGE") ?? [];
  return rows
    .filter((row) => row[0] && row[1])
    .map((row) => {
      const ctx = (field: string) => `[LID_USAGE] "${row[0]}" "${row[1]}" ${field}`;
      return {
        subcatchment: row[0],
        lidControl: row[1],
        number: parseNum(row[2], 0, ctx("Number"), warnings),
        area: parseNum(row[3], 0, ctx("Area"), warnings),
        width: parseNum(row[4], 0, ctx("Width"), warnings),
        initSat: parseNum(row[5], 0, ctx("Init Sat"), warnings),
        fromImperv: parseNum(row[6], 0, ctx("%Impervious"), warnings),
        toPerv: parseNum(row[7], 0, ctx("ToPerv"), warnings) > 0,
        reportFile: !row[8] || row[8] === "*" ? "" : row[8],
        drainTo: !row[9] || row[9] === "*" ? "" : row[9],
        fromPerv: parseNum(row[10], 0, ctx("%Pervious"), warnings),
      };
    });
}

export function writeLidUsage(
  raw: ReadonlyMap<string, string[][]>,
  usage: LidUsageRow[]
): Map<string, string[][]> {
  const rows = usage.map((u) => [
    u.subcatchment,
    u.lidControl,
    String(u.number),
    String(u.area),
    String(u.width),
    String(u.initSat),
    String(u.fromImperv),
    u.toPerv ? "1" : "0",
    u.reportFile || "*",
    u.drainTo || "*",
    String(u.fromPerv),
  ]);
  return writeOrDeleteSection(raw, "LID_USAGE", rows);
}
